import type { PropsWithChildren } from 'react';

import { Box } from '../../components/box';
import { Divider } from '../../components/divider';
import { Logo } from '../../components/logo';
import { Stack } from '../../components/stack';
import { Typography } from '../../components/typography';

export type PrintHeaderProps = PropsWithChildren<{
  applicationName: string;
}>;

export const PrintHeader = ({
  applicationName,
  children,
}: PrintHeaderProps) => {
  return (
    <Box
      className="dashboard-layout-print-header"
      sx={{
        display: 'none',
        displayPrint: 'block',
        paddingTop: 2,
        paddingX: 3,
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <Logo width={80} />
        <Typography>{applicationName}</Typography>
        {children && (
          <Divider orientation="vertical" flexItem variant="middle" />
        )}
        {children}
      </Stack>
    </Box>
  );
};
